import { useFormikContext } from 'formik';
import React, { useEffect } from 'react';

import { AutocompleteField } from '@components/FormFields';
import DropdownField from '@components/FormFields/DropdownField';
import { useEntitiesCreate } from '@hooks';
import { BLANK_OPTION, BLANK_RECORD_OPTION } from '@src/constants';
import { autocompleteEntities } from '@utils/backend-api/entities';
import {
  ENTITY_TYPE_SUB_ORGANIZATION_SUB_INDUSTRY,
  ENTITY_WORD_TYPE_COMMON,
  PROFILE_FIELD_OTHER_VALUE,
  PROFILE_OTHER_OPTION,
} from '@utils/backend-api/profileSettings';

import { StepProfileFormProps } from '../StepProfile';
import SubIndustryList from './SubIndustryList';

const SubIndustryFields = () => {
  const { values, setFieldValue, initialValues } = useFormikContext<StepProfileFormProps>();
  const { mutateAsync: createEntityAsync } = useEntitiesCreate();

  useEffect(() => {
    if (values.industry.value === PROFILE_FIELD_OTHER_VALUE) {
      setFieldValue('subIndustry', PROFILE_OTHER_OPTION);
      setFieldValue(
        'customSubIndustry',
        initialValues.customSubIndustry.value ? initialValues.customSubIndustry : BLANK_OPTION
      );
    } else if (initialValues.industry.value !== values.industry.value) {
      setFieldValue('subIndustry', BLANK_OPTION);
      ['customIndustry', 'customSubIndustry'].forEach((field) => {
        setFieldValue(field, BLANK_RECORD_OPTION);
      });
    }
  }, [
    values.industry.value,
    initialValues.industry.value,
    initialValues.customSubIndustry.value,
    initialValues,
    setFieldValue,
  ]);

  const showCustomField =
    values.subIndustry.value === PROFILE_FIELD_OTHER_VALUE &&
    ((values.industry.value === PROFILE_FIELD_OTHER_VALUE && values.customIndustry.value) ||
      values.industry.value !== PROFILE_FIELD_OTHER_VALUE);

  return (
    <>
      <DropdownField
        name="subIndustry"
        options={SubIndustryList[values.industry.value] || []}
        isDisabled={
          values.industry.value === '' ||
          (values.industry.value === PROFILE_FIELD_OTHER_VALUE && !values.customIndustry.value)
        }
        label="Sub-Industry&#42;"
        placeholder="Select"
        isClearable={false}
      />
      {showCustomField && (
        <AutocompleteField
          name="customSubIndustry"
          fetchMethod={(value) =>
            autocompleteEntities({
              fragment: value,
              entity_type: ENTITY_TYPE_SUB_ORGANIZATION_SUB_INDUSTRY,
            })
          }
          createMethod={(value) =>
            createEntityAsync({
              name: value,
              entity_type: ENTITY_TYPE_SUB_ORGANIZATION_SUB_INDUSTRY,
              word_type: ENTITY_WORD_TYPE_COMMON,
            })
          }
        />
      )}
    </>
  );
};

export default SubIndustryFields;
